module.exports = __webpack_public_path__ + "img/95cc3c4.jpg";